import { html } from 'lit';
const UserGuide =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.75 6.672v11.326c1.102-.479 2.388-.748 3.75-.748s2.648.27 3.75.748V6.672c-.997-.567-2.302-.922-3.75-.922s-2.753.355-3.75.922m9 0v11.326c1.102-.479 2.388-.748 3.75-.748s2.648.27 3.75.748V6.672c-.997-.567-2.302-.922-3.75-.922s-2.753.355-3.75.922m-.75-1.3c-1.247-.71-2.816-1.122-4.5-1.122-1.877 0-3.61.511-4.915 1.378a.75.75 0 0 0-.335.625v13a.75.75 0 0 0 1.165.625c1.031-.686 2.469-1.128 4.085-1.128s3.054.442 4.085 1.128a.75.75 0 0 0 .83 0c1.031-.686 2.469-1.128 4.085-1.128s3.054.442 4.085 1.128a.75.75 0 0 0 1.165-.625v-13a.75.75 0 0 0-.335-.625C20.11 4.761 18.377 4.25 16.5 4.25c-1.684 0-3.253.412-4.5 1.123" clip-rule="evenodd"/>
  </svg>
`;
export default UserGuide;
